export const UploadProgress = ({
  completedImages,
  currentImage,
  progress,
  startedAt,
  totalBytes,
  totalImages,
  uploadedBytes,
  visible,
}) => {
  const elapsedSeconds = startedAt ? Math.max((Date.now() - startedAt) / 1000, 0.1) : 0;
  const speedBytesPerSecond = uploadedBytes && elapsedSeconds ? uploadedBytes / elapsedSeconds : 0;
  const remainingBytes = Math.max((totalBytes || 0) - (uploadedBytes || 0), 0);
  const etaSeconds = speedBytesPerSecond ? remainingBytes / speedBytesPerSecond : null;

  return (
    <div className={visible ? 'row m-0 justify-content-center' : 'row m-0 justify-content-center hidden'} id="loadingContainer">
      <div className="col-12 mt-3 p-0">
        <div className="row m-0 p-4 inner-row bg-white">
          <div className="col-12 text-center pb-2">
            <h5 className="mb-1" id="loadingText">Uploading Images</h5>
            <p className="mb-0 text-muted">Please keep this page open until the upload completes.</p>
          </div>

          <div className="col-12 pb-2">
            <div className="progress w-100">
              <div
                className="progress-bar bg-green"
                role="progressbar"
                id="uploadProgress"
                aria-valuenow={progress}
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: `${progress}%` }}
              >
                {progress}%
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-4 pb-2 pb-md-0">
            <div className="bg-light rounded p-2 h-100 text-center">
              <small className="d-block text-muted">Images</small>
              <strong>{currentImage || completedImages || 0} / {totalImages || 0}</strong>
            </div>
          </div>
          <div className="col-12 col-sm-4 pb-2 pb-md-0">
            <div className="bg-light rounded p-2 h-100 text-center">
              <small className="d-block text-muted">Speed</small>
              <strong>{formatSpeed(speedBytesPerSecond)}</strong>
            </div>
          </div>
          <div className="col-12 col-sm-4">
            <div className="bg-light rounded p-2 h-100 text-center">
              <small className="d-block text-muted">ETA</small>
              <strong>{formatEta(etaSeconds)}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function formatSpeed(bytesPerSecond) {
  if (!bytesPerSecond) {
    return 'Starting...';
  }

  const units = ['B/s', 'KB/s', 'MB/s', 'GB/s'];
  let value = bytesPerSecond;
  let unitIndex = 0;

  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }

  return `${value.toFixed(value >= 10 ? 0 : 1)} ${units[unitIndex]}`;
}

function formatEta(seconds) {
  if (!Number.isFinite(seconds) || seconds === null) {
    return 'Calculating...';
  }

  if (seconds < 1) {
    return 'Almost done';
  }

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.ceil(seconds % 60);

  return minutes ? `${minutes}m ${remainingSeconds}s` : `${remainingSeconds}s`;
}

